import InfoBadge from './InfoBadge.jsx'

export default InfoBadge
